import React from 'react';
import Icon from '../Icon';
import svg from '../icons/borrowing.js';

const IconBorrowing = (props) => <Icon {...props} svg={svg} />;

IconBorrowing.displayName = 'IconBorrowing';

export default IconBorrowing;
